import { render, staticRenderFns } from "./talentPoolContent.vue?vue&type=template&id=2888c140&scoped=true"
import script from "./talentPoolContent.vue?vue&type=script&lang=js"
export * from "./talentPoolContent.vue?vue&type=script&lang=js"
import style0 from "./talentPoolContent.vue?vue&type=style&index=0&id=2888c140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888c140",
  null
  
)

export default component.exports